import {
  Dialog,
  DatePickerField,
  SubmissionForm,
  IDialogProps
} from "@bps/fluent-ui";
import { TtmReportingSnapshotOptions } from "@libs/api/gateways/ttm/reporting/ttm-reporting-ops-gateway.dtos";

interface SnapshotOptionsModalProps extends Pick<IDialogProps, "onDismiss"> {
  onSubmit: (options: TtmReportingSnapshotOptions) => Promise<void>;
}

export const SnapshotOptionsModal = ({
  onDismiss,
  onSubmit
}: SnapshotOptionsModalProps) => {
  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{ showCloseButton: true, title: "Snapshot" }}
    >
      <SubmissionForm<TtmReportingSnapshotOptions>
        initialValues={{}}
        submitButtonProps={{ title: "Send" }}
        cancelButtonProps={{ title: "Close", onClick: () => onDismiss?.() }}
        onSubmit={onSubmit}
      >
        {() => (
          <>
            {" "}
            <DatePickerField name="startDate" label="Start date" />
            <DatePickerField name="endDate" label="End date" />
          </>
        )}
      </SubmissionForm>
    </Dialog>
  );
};
